import { createAction } from "redux-actions";

export const SET_LANGUAGE = "SET_LANGUAGE";
export const setLanguage = createAction(SET_LANGUAGE);
